// Copied from the nowadays repo, packages/ui/src/components/spinner.tsx at 6da58398f. Change it there first, then copy it here, rewriting any em dash (this repo bans them).
import { cn } from "@/nowadays-ui/lib/utils"
import { Loader2Icon } from "lucide-react"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon data-slot="spinner" role="status" aria-label="Loading" className={cn("size-4 animate-spin", className)} {...props} />
  )
}

export { Spinner }
